import React, { useEffect, useRef, useState } from 'react';

import { Content, HeaderSection } from './components';
import { UncreditedReservationsProvider } from './UncreditedReservationsContext';

const UncreditedReservations = (): JSX.Element => {
  const headerRef = useRef<HTMLDivElement>(null);
  const [headerHeight, setHeaderHeight] = useState(0);

  useEffect(() => {
    if (headerRef.current) {
      setHeaderHeight(headerRef.current.offsetHeight);
    }
  }, []);

  return (
    <UncreditedReservationsProvider>
      <div ref={headerRef}>
        <HeaderSection />
      </div>
      <Content headerHeight={headerHeight} />
    </UncreditedReservationsProvider>
  );
};

export default UncreditedReservations;
